import { ServiceBase } from 'travco-services';

class InventoryService extends ServiceBase {
    constructor(token) {
        super();
        this._token = token;
    }

    get(id) {
        return super.fetch('/api/inventory/' + id, 'get', null, this._token);
    }

    search(request) {
        return super.fetch('/api/inventory/search', 'post', JSON.stringify(request), this._token);
    }

    checkInventoryExist(model) {
        return super.fetch('/api/inventory/CheckBookingInventory', 'post', JSON.stringify(model), this._token);
    }

    save(model) {
        let inventoryId = '';

        if (document.URL.indexOf('Inventory_') > 0) {
            let split = document.URL.split('/');
            inventoryId = split.length > 4 ? split[4] : null;
            model.id = inventoryId;
        }

        if (model.id) {
            return super.fetch('/api/inventory/update', 'put', JSON.stringify(model), this._token);
        } else {
            return super.fetch('/api/inventory/save', 'post', JSON.stringify(model), this._token);
        }
    }

    getPrice(hotel, date) {
        let request = {
            hotel: hotel,
            date: date
        };
        return super.fetch('/api/inventory/getPrice', 'post', JSON.stringify(request), this._token);
    }

    getPrices(hotel, startDate, endDate) {
        let request = {
            rates: { ratePlan: { hotel: hotel } },
            startDate: startDate,
            endDate: endDate
        };
        return super.fetch('/api/inventory/getPrices', 'post', JSON.stringify(request), this._token);
    }

    getPolicies(hotel) {
        let request = {
            hotel: hotel
        };
        return super.fetch('/api/inventory/getPolicies', 'post', JSON.stringify(request), this._token);
    }
}

export default InventoryService;
